import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { elementInteraction } from '@nerdwallet/nw-client-lib/tracking';
import NavigateLeft from '@nerdwallet/react-icon/gizmo/Navigateleft';
import NavigateRight from '@nerdwallet/react-icon/gizmo/Navigateright';
import trackCarouselInteracted from './utils';

var handleClick = function handleClick(e, _ref) {
  var id = _ref.id,
      impression = _ref.impression,
      elementContent = _ref.elementContent,
      onClick = _ref.onClick;
  trackCarouselInteracted(id, impression, 'press');
  elementInteraction({
    elementName: "carousel__nav-arrows--".concat(id),
    interactionType: 'CLICK',
    sectionCategory: 'carousel',
    elementCategory: 'nav-arrows',
    elementDomType: 'button',
    elementContent: elementContent
  });

  if (onClick) {
    onClick(e);
  }
};

export var ArrowPrev = function ArrowPrev(_ref2) {
  var className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ["className"]);

  return /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(event) {
      return handleClick(event, _objectSpread({
        elementContent: 'prev'
      }, props));
    },
    className: className,
    type: "button"
  }, /*#__PURE__*/React.createElement(NavigateLeft, null));
};
export var ArrowNext = function ArrowNext(_ref3) {
  var className = _ref3.className,
      props = _objectWithoutProperties(_ref3, ["className"]);

  return /*#__PURE__*/React.createElement("button", {
    onClick: function onClick(event) {
      return handleClick(event, _objectSpread({
        elementContent: 'next'
      }, props));
    },
    className: className,
    type: "button"
  }, /*#__PURE__*/React.createElement(NavigateRight, null));
};
var arrowPropTypes = {
  /** ID used for tracking purposes. */
  id: PropTypes.string,

  /** Classes to apply to the arrow. */
  className: PropTypes.string,

  /** Optional click handler to call after default navigation. */
  onClick: PropTypes.func,

  /** The impression fired by the parent Carousel */
  impression: PropTypes.string
};
ArrowPrev.propTypes = arrowPropTypes;
ArrowNext.propTypes = arrowPropTypes;